import React from 'react';

interface NeumorphicSwitchProps {
  isEatOut: boolean;
  onToggle: () => void;
  className?: string;
}

const NeumorphicSwitch: React.FC<NeumorphicSwitchProps> = ({
  isEatOut,
  onToggle,
  className,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle();
    }
  };

  return (
    <div
      className={`relative inline-flex items-center bg-muted rounded-full p-1 ${className ?? ''}`}
      data-tour="mode-switch"
      role="group"
      aria-label="Dining mode"
    >
      {/* Sliding pill */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-1 bottom-1 rounded-full bg-black shadow-sm"
        style={{
          left: isEatOut ? 4 : 'calc(50%)',
          width: 'calc(50% - 4px)',
          transition: 'left 500ms ease-in-out',
        }}
      />

      {/* Eat Out */}
      <button
        onClick={isEatOut ? undefined : onToggle}
        onKeyDown={handleKeyDown}
        role="radio"
        aria-checked={isEatOut}
        className={`relative z-10 flex-1 text-sm px-3 py-2 rounded-full transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-border ${
          isEatOut ? 'text-foreground' : 'text-muted-foreground'
        }`}
      >
        🍽️
      </button>

      {/* Eat In */}
      <button
        onClick={!isEatOut ? undefined : onToggle}
        onKeyDown={handleKeyDown}
        role="radio"
        aria-checked={!isEatOut}
        className={`relative z-10 flex-1 text-sm px-3 py-2 rounded-full transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-border ${
          !isEatOut ? 'text-foreground' : 'text-muted-foreground'
        }`}
      >
        🥡
      </button>
    </div>
  );
};

export default NeumorphicSwitch;
